import Text from 'components/common/Text';
import ThankYouButton from 'components/signUpFunnel/thankYou/ThankYouButton';

const SmartPhoneLegalCopy = ({ onClick, postSignupUrl, user }) => {
  return (
    <>
      <div className="pb-1">
        <ThankYouButton
          onClick={onClick}
          postSignupUrl={postSignupUrl}
          user={user}
          buttonStyles="w-full"
        />
      </div>
      <div className="mb-6">
        <Text brandStylesOverrides="textSm" className="mb-8 text-left text-charcoal-90">
          Valid for new customers only. Referral credit limited to one per new household address,
          and cannot be combined with any other Home Chef offers, promotions, or discounts. Your
          promotional discount recipient can freely choose to skip or cancel future deliveries free
          of charge once they redeem their referral credit.
        </Text>
        <Text brandStylesOverrides="textSm" className="text-left text-charcoal-90">
          You agree to share your Home Chef referral link only with your own personal connections
          via email, your own social media accounts, and personal blogs where you are the primary
          content owner. Public distribution on sites where you are not the primary content owner,
          e.g. Home Chef’s social media pages and coupon websites, is not allowed. We reserve the
          right to suspend your account and/or revoke any and all referral credits at any time if we
          believe that your credits were inappropriately earned.
        </Text>
      </div>
    </>
  );
};

SmartPhoneLegalCopy.propTypes = {
  onClick: PropTypes.func.isRequired,
  postSignupUrl: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

export default SmartPhoneLegalCopy;
